// constants
import ACTIONS from "../../constants/actions";

const {
  REQUEST_DELETE_REASON_LOADING,
  REQUEST_DELETE_REASON_SUCCESS,
  REQUEST_DELETE_REASON_FAIL,
} = ACTIONS;

const initialState = {
  isLoading: false,
  data: null,
  error: null,
};

export const popupDeleteReasonReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DELETE_REASON_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case REQUEST_DELETE_REASON_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    case REQUEST_DELETE_REASON_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.message,
      };
    default:
      return state;
  }
};
